import * as React from "react";

import {
  Timeline,
  Text,
  Badge,
  Divider,
  Alert,
  Flex,
  Radio,
  ScrollArea,
} from "@mantine/core";
import {
  IconAlertCircle,
  IconAnchor,
  IconDatabase,
  IconEdit,
  IconFileUpload,
  IconFilter,
  IconFingerprint,
  IconFlag,
  IconNotification,
  IconRun,
} from "@tabler/icons-react";
import dayjs from "dayjs";

function getColor(type: string) {
  if (type.toLowerCase() === "error") {
    return "pink";
  } else if (type.toLowerCase() === "warning") {
    return "yellow";
  } else {
    return "gray";
  }
}

export default function Events({
  events,
}: {
  events: {
    id: string;
    runId: string;
    runSeq: string;
    type: string;
    code: string;
    description: string;
    severity: string;
    status: string;
    eventDate: Date;
    details: any;
  }[];
}) {
  const [type, setType] = React.useState("ALL");

  const filteredEvents = (events || []).filter(
    (event) => event.type === type || type === "ALL"
  );

  return (
    <>
      <Flex>
        <Radio
          mr="lg"
          checked={type === "ALL"}
          onChange={() => {
            setType("ALL");
          }}
          label="All"
        />
        <Radio
          mr="lg"
          checked={type === "INFO"}
          onChange={() => {
            setType("INFO");
          }}
          label="Info"
        />
        <Radio
          mr="lg"
          checked={type === "WARNING"}
          onChange={() => {
            setType("WARNING");
          }}
          label="Warning"
        />
        <Radio
          mr="lg"
          checked={type === "ERROR"}
          onChange={() => {
            setType("ERROR");
          }}
          label="Error"
        />
        <Radio
          mr="lg"
          checked={type === "EXCEPTION"}
          onChange={() => {
            setType("EXCEPTION");
          }}
          label="Exception"
        />
      </Flex>

      <>
        {filteredEvents.length > 0 ? (
          <ScrollArea
            style={{ height: 250 }}
            offsetScrollbars
            scrollbarSize={16}
          >
            {filteredEvents.map((event, index) => {
              return (
                <Alert
                  key={event.id}
                  variant="light"
                  mt="xs"
                  icon={<IconAlertCircle size={16} />}
                  title={event.code}
                  color={getColor(event.type)}
                >
                  {event.description}
                </Alert>
              );
            })}
          </ScrollArea>
        ) : (
          <Divider label="No Events" labelPosition="left" />
        )}
      </>
    </>
  );
}
